<template>
  <div class="form-field" :rel="name"
       v-bind:class="{'form-required': requiredForm, 'has-lang':lang, 'form-readonly': readOnly, 'form-focus': focus, 'form-disabled':isDisabled}">
    <div class="form-label" v-show="label">{{ label }}</div>
    <div class="form-hint" v-show="hint">{{ hint }}</div>
    <div class="form-input">
      <div class="form-input-wrapper">
                <textarea v-model="internalValue"
                          :placeholder="placeholder"
                          :maxlength="maxlength"
                          :readonly="readOnly"
                          :disabled="isDisabled"
                          @focus="focus=true"
                          @blur="focus=false"></textarea>
        <div class="form-translations" v-if="translations && Object.keys(translations).length > 1" style="position: absolute;top: 0;right: 0;">
          <Translator @updateValue="updateValue" :translate-key="translateKey" :lang="lang" v-model="translations" />
          <i :class="langClass" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Translator from "./Translator.vue";
export default {
  name: 'FormFieldTextarea',
  props: ['value', 'label', 'hint', 'name', 'placeholder', 'lang', 'translateKey', 'translations', 'lang', 'required', 'maxlength', 'readonly', 'disabled'],
  components: {Translator},
  data: function () {
    return {
      internalValue: '',
      langClass: '',
      focus: false
    }
  },
  created: function () {
    this.internalValue = this.value;
    this.langClass = this.lang ? "flag lang-" + this.lang : "";
    this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
    this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
    this.setDisabled(this.disabled)
  },
  methods: {
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    },
    updateValue: function (val) {
      this.internalValue = val
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'value'(newVal, oldVal) {
      this.internalValue = newVal
    },
    'internalValue'(newVal, oldVal) {
      this.$emit('input', this.internalValue);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/Textarea.vue